module.exports = __webpack_public_path__ + "img/juzhen_item_bg.12f24792.png";